<template>
  <div v-if="!isPrint">
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
    />

    <!-- 점검대상 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot" /> 점검대상</h5>
      <div class="grid lg:grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-2 flex items-center" v-for="checkbox in form.inspectList" v-bind:key="checkbox.id">
          <div v-if="isPrint || board.readonly" class="flex">
            <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            {{ checkbox.title }}
          </div>
          <label v-else class="flex">
            <vs-checkbox :readonly="board.readonly" :vs-value="checkbox.title" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
            {{ checkbox.title }}
          </label>
        </div>
      </div>
    </div>

    <TableInspectMerge
      v-for="(inspection, inspection_i) in form.inspectList"
      :key="`inspection_${inspection_i}`"
      v-show="inspection.check"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :title="inspection.title"
      tableHeaderTitle="착안사항"
      :tableHeaderNote="[{ text: '개선요망 사항', width: 320 }, { text: '비고', width: 320 }]"
      v-model="inspection.list"
      class="mt-28px"
    />

    <!-- 현장근로자 의견 청취 및 특이사항 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 현장근로자 의견 청취 및 특이사항</h5>
      <div class="writeGridContainer">
        <div>
          <div>현장근로자 의견 청취</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_1.fileName }}</p>
          <file-uploader v-else :readonly="board.readonly" v-model="form.inputC_1" />
        </div>
        <div class="writeGridLineItem">
          <div>특이사항</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputC_2 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputC_2" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 결재란 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i> 결재란</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" class="mt-28px" />

    <!-- 파일첨부 -->
    <file-upload-module v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" class="mt-28px"></file-upload-module>
  </div>
  <print v-else :board="board" :form="form"/>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploader from "@/components/FileUploader";
import TableInspectMerge from "@/components/TableInspectMerge";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import Print from "./Print.vue";

export default {
  components: {
    Print,
    NameWithSignatureRow,
    TableInspectMerge,
    FileUploader,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  methods: {
    checkForm() {
      this.form.typeTitleList = [];
      for (const data of this.form.inspectList) {
        if (data.check) {
          this.form.typeTitleList.push(data.title);
        }
      }
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inputC_1: {},
        inputC_2: "",

        typeTitleList: [],
        inspectList: [
          {
            check: false,
            title: "작업장환경",
            list: [
              {
                content: "1. 작업장내 안전통로는 확보되어 있는가?",
                isChecked: "",
              },
              {
                content: "2. 바닥은 미끄럽거나 넘어질 위험이 있는가?",
                isChecked: "",
              },
              {
                content: "3. 출입구, 비상구 주변에 물건을 두고 있는가?",
                isChecked: "",
              },
              {
                content: "4. 이동시 바닥의 상태, 턱, 장애물 유무 확인하는 가?",
                isChecked: "",
              },
              {
                content: "5. 물건(이동),사용시 날카로움, 베일 우려가 있는지 확인하는가?",
                isChecked: "",
              },
              {
                content: "6. 계단끝단 미끄럼방지조치, 계단난간 설치 및 이동통로에 적정 조도는 확보되었는가?",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "건강상태",
            list: [
              {
                content: "1. 근로자들의 휴식시간 제공과 휴게시설이 설치 되어 있는가?",
                isChecked: "",
              },
              {
                content: "2. 근로자의 건강보호 유지를 위하여 정기적인 건강 검진을 실시하고 있는가?",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "전기안전",
            list: [
              {
                content: "1. 멀티탭 먼지없이 청결하게 유지되고 있는지 여부 확인",
                isChecked: "",
              },
              {
                content: "2. 전기안전(전열기구,전선,콘센트 등)육안점검 - 문어발식 연결 상태, 전선의 피복 손상, 커버 파손 여부 등",
                isChecked: "",
              },
              {
                content: "3. 전선이 꼬이거나 무거운 물건에 눌려있는지 여부 확인(육안점검)",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "비상구",
            list: [
              {
                content: "1. 비상시 사무실 내에서 탈출할 수 있는 비상구가 마련되어 있는가?",
                isChecked: "",
              },
              {
                content: "2. 비상구임을 알아볼 수 있는 표시를 근로자의 눈에 띄기 쉬운 곳에 부착하였는가?",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "근골격계질환",
            list: [
              {
                content: "1. 장시간 앉아있는 자세로 작업하는가?(하루 4시간 이상)",
                isChecked: "",
              },
              {
                content: "2. 하루 4시간 이상 집중적으로 자료입력 등을 위한 키보드/마우스 조작작업에 해당이 되는가?",
                isChecked: "",
              },
              {
                content: "3. 하루 4시간 이상 거북목 유지 등 불안정한 자세로 작업하는가?",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "게시상태",
            list: [
              {
                content: "1. 법령요지 게시 여부",
                isChecked: "",
              },
              {
                content: "2. 안전보건표지 부착 여부",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "안전보건교육",
            list: [
              {
                content: "1. 안전보건교육을 정기적으로 실시하고 있는가?",
                isChecked: "",
              },
              {
                content: "2. 신규채용자의 안전보건교육은 별도로 실시하고 있는가?",
                isChecked: "",
              },
            ],
          },
          {
            check: false,
            title: "소방안전",
            list: [
              {
                content: "1. 소화기의 충전 상태는?",
                isChecked: "",
              },
              {
                content: "2. 소화기 호스의 균열 및 노즐의 파손 상태는?",
                isChecked: "",
              },
              {
                content: "3. 소화기의 월별 점검표 및 사용법 부착 상태는?",
                isChecked: "",
              },
              {
                content: "4. 대피로는 제대로 확보 되어 있는가?",
                isChecked: "",
              },
              {
                content: "5. 소화기는 눈에 띄는 곳에 비치되어 있는가?",
                isChecked: "",
              },
            ],
          },
        ],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },

        photoList: [],
        fileList: [],


      },
    };
  },
};
</script>
